import { Field, useFormikContext } from "formik";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DeleteIcon from "../../../assets/icons/delete-icon";
import "../../forms/form.css";
import SearchAddFeild from "../../forms/search-add-field";
import errorToast from "../../helper-components/error-toast";
import useBarcodeScanner from "../../helper-components/helper-function";
import { invoiceScannedItemAction } from "../../../redux/actions/invoices-action";
import SelectField from "../../forms/select-field";
import { stockTransferBatchAction } from "../../../redux/actions/inventory-action";
import {
  purchaseProductDetailsAction,
  purchaseProductListAction,
} from "../../../redux/actions/purchase-action";
import AddButton from "../../buttons/button";

const StocktransferItemSec = ({
  initialData,
  disabled = false,
  searchRef,
  addBatchFn = () => { },
  heading = [],
}) => {
  const inputRefs = useRef(null);
  const { values, setFieldValue } = useFormikContext();

  // Block adding items until both source (from) and destination (to)
  // warehouses are selected.
  const isWarehouseSelected =
    values?.from_warehouse_id?.length > 0 &&
    values?.to_warehouse_id?.length > 0;

  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);
  // const heading = [
  //   { label: "S No.", value: "sl_no" },
  //   { label: "Product Name", value: "item_name" },
  //   { label: "Item Code", value: "item_code" },
  //   { label: "UOM", value: "item_uom" },
  //   { label: "Qty", value: "item_quantity" },
  //   {
  //     label: "Batches",
  //     value: "item_batches",
  //     enabled: true,
  //     alignment: "center",
  //     childrenHeading: [
  //       {
  //         label: "Batch",
  //         value: "item_batch_number",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Final PR",
  //         value: "item_batch_purchase_rate",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "MRP",
  //         value: "item_batch_unit_price",
  //         enabled: true,
  //         minWidth: 10,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Quantity",
  //         value: "item_batch_quantity",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Free Quantity",
  //         value: "item_batch_free_quantity",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //       {
  //         label: "Expiry",
  //         value: "item_exp_date",
  //         enabled: true,
  //         minWidth: 100,
  //         alignment: "center",
  //       },
  //     ],
  //   },

  //   { label: "Current Avail", value: "current_availability" },
  //   { label: "Clear All", value: "clear_all" },
  // ];
  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const options =
        data?.data === null
          ? []
          : data.data
            .map((item) => ({
              value: item.item_id,
              label: item[field],
            }))
            .filter(
              (option) =>
                !values?.data?.some((item) => item?.item_id === option.value)
            );
      setLocalData(data.data);
      callback(options);
    };
    const onError = (data) => { };
    if (inputValue?.length > 0) {
      dispatch(
        // productListAction(
        purchaseProductListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const removeRow = (rowIndex) => {
    const updatedData = [...values.data];
    updatedData.splice(rowIndex, 1);
    setFieldValue("data", updatedData);
  };

  const handleQuantityChange = async (event, rowIndex) => {
    const updatedData = values.data.map((row, index) =>
      index === rowIndex
        ? { ...row, quantity: parseFloat(event.target.value) }
        : row
    );
    setFieldValue("data", updatedData);
  };

  const hasDuplicateItemId = (itemId, currentIndex) => {
    const itemIdsExceptCurrent = values.data
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.item_id);

    return itemIdsExceptCurrent.includes(itemId);
  };

  useBarcodeScanner((barcode) => {
    if (barcode && isWarehouseSelected) {
      dispatch(
        invoiceScannedItemAction(barcode, onSuccessScanned, onErrorScanned)
      );
    }
  });

  const onSuccessScanned = (data) => {
    const itemData = data?.data?.item_information;
    if (
      !values?.data?.some(
        (item) => item?.item_id === data?.data?.item_information?.item_id
      )
    ) {
      const newdata = {
        sl_no: 1,
        item_name: itemData?.item_name,
        item_generic_name: itemData?.item_generic_name,
        item_code: itemData?.item_code,
        item_uom: itemData?.item_uom,
        item_unit_price: itemData?.item_unit_price,
        quantity: 1,
        item_total_amount:
          parseFloat(itemData?.item_unit_price) * 1 -
          data.data.discount_details?.item_discount_amount +
          data.data.discount_details?.item_tax_amount,
        item_id: itemData?.item_id,
        item_tax_amount: data.data.discount_details?.item_tax_amount,
        item_gst: data.data.discount_details?.item_total_tax_percentage,
        item_sgst: (
          (parseFloat(itemData?.item_unit_price) -
            parseFloat(data.data.discount_details?.item_discount_amount)) *
          (data.data.discount_details?.sgstRate / 100)
        )?.toFixed(2),
        item_cgst: (
          (parseFloat(itemData?.item_unit_price) -
            parseFloat(data.data.discount_details?.item_discount_amount)) *
          (data.data.discount_details?.cgstRate / 100)
        )?.toFixed(2),
        item_igst: (
          (parseFloat(itemData?.item_unit_price) -
            parseFloat(data.data.discount_details?.item_discount_amount)) *
          (data.data.discount_details?.igstRate / 100)
        )?.toFixed(2),
      };
      const oldData = [...values?.data];
      oldData.pop();
      setFieldValue("data", [...oldData, newdata, initialData]);
    } else {
      errorToast(
        "Item already added to invoice. Please adjust quantity if you wish to add more."
      );
    }
  };
  const onErrorScanned = (data) => {
    errorToast(data?.data?.message);
  };

  function fetchBatchfn(id, index) {
    dispatch(
      stockTransferBatchAction(
        id,
        (data) => {
          if (index) {
            setFieldValue(`data[${index}].itemBatchList`, data?.data);
          }
        },
        (data) => { }
      )
    );
  }

  const onSuccessDetails = (data, rowIndex, filteredData) => {
    const oldData = [...values?.data];
    oldData.pop();
    const rawUomList = data?.data?.uom_dropdown ?? [];
    // Find the default UOM: try ID match → name match → first entry as last resort
    const matchedUom =
      rawUomList.find((uom) => uom?.item_id === filteredData?.item_uom_id) ??
      rawUomList.find((uom) => uom?.alt_uom === filteredData?.item_uom) ??
      rawUomList[0];
    const resolvedBaseQty = parseFloat(matchedUom?.base_quantity) || 1;
    const rawSellableQuantity =
      parseFloat(data?.data?.total_sellable_quantity) || 0;
    const updatedData = {
      ...filteredData,
      base_quantity: resolvedBaseQty,
      item_uom_id: matchedUom?.item_id ?? filteredData?.item_uom_id,
      base_total_sellable_quantity: rawSellableQuantity,
      total_sellable_quantity: rawSellableQuantity / resolvedBaseQty,
      uom_dropdown: rawUomList.map((uom) => ({
        item_uom_id: uom?.item_id,
        label: uom?.alt_uom,
        value: uom?.alt_uom,
        base_quantity: uom?.base_quantity,
      })),
    };

    setFieldValue("data", [...oldData, updatedData, initialData]);
    inputRefs.current?.focus();
  };

  const onErrorDetails = (data) => { };

  return (
    <>
      <div
        style={{
          maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
          height: "auto", // Let it grow naturally to fit its content
        }}
        className={`border border-[var(--create-table-main-border)] border-1 border-radius px-3 pb-3`}
      >
        <div
          style={{
            maxHeight: `100%`,
            minHeight: `5rem`,
          }}
          className={`tab-container border-radius mt-[1rem]`}
        >
          <table className="w-full border-collapse mt-0">
            <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
              <tr className="relative h-[50px]">
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => (
                    <th
                      style={{ minWidth: `${heading?.minWidth}px` }}
                      key={index}
                      className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                    >
                      {heading?.value === "clear_all" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                            width: "100%", // Ensure the div takes full width of the th
                          }}
                        >
                          {!disabled && (
                            <AddButton
                              type="button"
                              onclkFn={() => {
                                if (values?.data?.length > 0) {
                                  removeRow(0, "all");
                                }
                              }}
                              prefixIcon={false}
                              text={"Clear All"}
                              className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                            />
                          )}
                        </div>
                      ) : heading?.childrenHeading?.length > 0 ? (
                        <div className="flex gap-3">
                          {heading?.childrenHeading?.map(
                            (childHeading, childIndex) => (
                              <div
                                style={{
                                  minWidth: `100px`,
                                  width: `${heading?.minWidth}px`,
                                  textAlign: childHeading?.alignment, // Keep textAlign for normal text cells
                                }}
                                className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                              text-[length:var(--create-table-batch-con-fs)] 
                              font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                              >
                                {childHeading?.label}
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 w-full"
                          style={{
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                  ? "center"
                                  : "flex-start",
                          }}
                        >
                          {heading?.label}
                        </div>
                      )}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="h-full">
              {values?.data?.map((rowData, rowIndex) => (
                <tr
                  className={` bg-[var(--create-table-row-bg)] h-[50px] `}
                  key={rowIndex}
                >
                  {heading
                    ?.filter((heading) => heading?.enabled !== false)
                    ?.map((heading, index) => {
                      return (
                        <td
                          style={{
                            minWidth: `${heading?.minWidth}px`,
                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                          }}
                          key={index}
                          className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                        >
                          {heading.value === "item_name" ||
                            heading.value === "item_code" ||
                            heading.value === "item_generic_name" ? (
                            <div title={rowData[heading.value]}>
                              <SearchAddFeild
                                menuWidth="35rem"
                                searchRef={
                                  heading.value === "item_name" ? searchRef : {}
                                }
                                isDisabled={
                                  values?.data?.length - 1 !== rowIndex ||
                                    disabled ||
                                    !isWarehouseSelected
                                    ? true
                                    : false
                                }
                                errorClass="hidden"
                                isRequired={false}
                                value={{
                                  label: rowData[heading.value],
                                  value: "",
                                }}
                                name={`data[${rowIndex}].${heading.value}`}
                                field={heading.value}
                                isLabelReq={false}
                                defaultSelectClass=""
                                placeholder=""
                                fetchData={fetchData}
                                onChange={async (selectedOption) => {
                                  const filteredData = localData
                                    ?.filter(
                                      (item) =>
                                        item?.item_id === selectedOption?.value
                                    )
                                    .map((item) => ({
                                      sl_no: 1,
                                      item_name: item.item_name,
                                      item_code: item.item_code,
                                      item_uom:
                                        item.item_pur_purchasing_uom_name ===
                                          null
                                          ? ""
                                          : item.item_pur_purchasing_uom_name,
                                      quantity: 0,
                                      item_batches: [],
                                      current_avail: {
                                        item_uom_source: "",
                                        item_uom_destination: "",
                                      },
                                      total_sellable_quantity: 0,
                                      base_total_sellable_quantity: 0,
                                      item_id: item?.item_id,
                                      uom_dropdown: [],
                                      // uom_dropdown: item?.uom_dropdown
                                      //   ? item?.uom_dropdown.map((uom) => ({
                                      //       item_uom_id: uom?.item_id,
                                      //       label: uom?.alt_uom,
                                      //       value: uom?.alt_uom,
                                      //       base_quantity: uom?.base_quantity,
                                      //     }))
                                      //   : [],
                                      item_uom_id:
                                        item?.item_pur_purchasing_uom_name_id ??
                                        "",
                                      base_quantity: 0,
                                      // base_quantity: item?.uom_dropdown
                                      //   ? parseInt(
                                      //       item?.uom_dropdown.find(
                                      //         (uom) =>
                                      //           uom?.item_id ===
                                      //           item?.item_pur_purchasing_uom_name_id
                                      //       )?.base_quantity ?? 0
                                      //     ) || 0
                                      //   : 0,
                                      uom_group_id: item?.item_uom || "",
                                    }));
                                  dispatch(
                                    purchaseProductDetailsAction(
                                      {
                                        item_id: filteredData?.[0]?.item_id,
                                        item_uom:
                                          filteredData?.[0]?.uom_group_id,
                                      },
                                      (data) => {
                                        onSuccessDetails(
                                          data,
                                          rowIndex,
                                          ...filteredData
                                        );
                                      },
                                      onErrorDetails
                                    )
                                  );
                                }}
                              />
                            </div>
                          ) : heading.value === "item_quantity" ? (
                            <div className="flex w-full">
                              <Field name={`data[${rowIndex}].quantity`}>
                                {({ field }) => (
                                  <input
                                    min={0}
                                    ref={inputRefs}
                                    {...field}
                                    type="number"
                                    step="1"
                                    placeholder=""
                                    // disabled={!values.data[rowIndex]?.item_uom}
                                    readOnly={
                                      values?.data?.length - 1 === rowIndex ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled
                                    }
                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "-" ||
                                        event.key === "e" ||
                                        event.key === "."
                                      ) {
                                        event.preventDefault();
                                      }
                                      if (
                                        event.key === "Tab" ||
                                        event.key === "Enter"
                                      ) {
                                        handleQuantityChange(event, rowIndex);
                                        setFieldValue(
                                          `data[${rowIndex}].quantity`,
                                          event.target.value
                                        );
                                        // if (searchRef && searchRef.current) {
                                        //   setTimeout(() => {
                                        //     searchRef.current.focus();
                                        //   }, 0);
                                        // }
                                      }
                                    }}
                                    onFocus={(e) => e.target.select()}
                                    className="focus-within:ring-2 min-w-[3rem] max-w-[5rem]  px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading.value === "item_uom" ? (
                            <SelectField
                              defaultInputClass="min-h-[42px] rounded-[8px]  text-[var(--create-table-row-fg-color)] text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] input-field-no-spin-buttons placeholder:text-[var(--create-table-row-placeholder-color)] placeholder:text-[length:var(--create-table-batch-con-fs)] placeholder:font-[var(--create-table-row-font-weight)]  "
                              borderclass=""
                              defaultSelectClass="border-0"
                              inputBorder=""
                              general_color={false}
                              handleSelected={(sel) => {
                                const newBaseQty =
                                  parseFloat(sel?.base_quantity) || 1;
                                const rawSellableQuantity =
                                  parseFloat(
                                    rowData?.base_total_sellable_quantity
                                  ) || 0;
                                setFieldValue(
                                  `data[${rowIndex}].item_uom_id`,
                                  sel?.item_uom_id
                                );
                                setFieldValue(
                                  `data[${rowIndex}].base_quantity`,
                                  newBaseQty
                                );
                                setFieldValue(
                                  `data[${rowIndex}].total_sellable_quantity`,
                                  rawSellableQuantity / newBaseQty
                                );
                              }}
                              value_color="var(--secondary)"
                              selectClass="w-full"
                              defaultValue={
                                values.data[rowIndex]?.item_uom
                                  ? {
                                    label:
                                      values.data[rowIndex]?.item_uom ?? "",
                                  }
                                  : null
                              }
                              isDisabled={disabled}
                              errMsgContainerClass="hidden"
                              id={`data[${rowIndex}].item_uom`}
                              isContainer={false}
                              options={values.data[rowIndex]?.uom_dropdown}
                              name={`data[${rowIndex}].item_uom`}
                              placeholder={"Select UOM"}
                              style={customStyles}
                            />
                          ) : heading.value === "item_batches" ? (
                            <div className="py-1">
                              {rowIndex < values?.data?.length - 1 &&
                                values?.stock_management_action !==
                                "stock_transfer_request" &&
                                values.data[rowIndex]?.quantity > 0 &&
                                rowData.item_batches?.length === 0 && (
                                  <button
                                    onClick={() => {
                                      addBatchFn(rowData?.item_id);
                                    }}
                                    type="button"
                                    className="text-[var(--create-table-row-placeholder-color)]   w-full"
                                  >
                                    {disabled
                                      ? "View batch details"
                                      : "Click to" +
                                        rowData.item_batches?.length >
                                        0
                                        ? "Update"
                                        : "Add"}
                                  </button>
                                )}

                              {Array.isArray(rowData.item_batches) &&
                                rowData.item_batches.map((batch, index) => (
                                  <div
                                    onClick={() => addBatchFn(rowData?.item_id)}
                                    className="flex items-center gap-3 mt-[0.5rem]"
                                  >
                                    {heading?.childrenHeading
                                      ?.filter(
                                        (heading) => heading?.enabled !== false
                                      )
                                      ?.map((heading, index) => (
                                        <div
                                          style={{
                                            minWidth: `100px`,
                                            width: `${heading?.minWidth}px`,
                                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                                          }}
                                          className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                                      text-[length:var(--create-table-batch-con-fs)] 
                                      font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                                        >
                                          {batch[heading?.value] ?? "-"}
                                        </div>
                                      ))}
                                  </div>
                                ))}
                            </div>
                          ) : heading.value === "clear_all" ? (
                            <button
                              type="button"
                              onClick={() => {
                                removeRow(rowIndex, "");
                              }}
                              style={{
                                display: "flex",
                                justifyContent:
                                  heading?.alignment === "right"
                                    ? "flex-end"
                                    : heading?.alignment === "center"
                                      ? "center"
                                      : "flex-start",
                                width: "100%", // Take full width of the td
                              }}
                            >
                              {!disabled && (
                                <DeleteIcon className="cursor-pointer text-red-500" />
                              )}
                            </button>
                          ) : heading.value === "sl_no" ? (
                            rowIndex + 1
                          ) : (
                            rowData[heading.value] ?? "--"
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default StocktransferItemSec;

const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    fontFamily: "Inter,sans-serif ",
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
    borderRadius: "10px",
    width: "100%",
    backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    height: "100%",
  }),
  option: (provided, state) => {
    const defaultBackgroundColor = "white"; // Default background color
    const focusedBackgroundColor = "#0000002E"; // Background color when focused
    const selectedBackgroundColor = "#e5ecffb2"; // Background color when selected

    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      // backgroundColor: state?.isSelected ? "red" : "red",
      backgroundColor: state.isSelected
        ? selectedBackgroundColor // Use selected background color
        : state.isFocused
          ? focusedBackgroundColor // Use focused background color
          : defaultBackgroundColor, // Use default background color

      fontSize: "14px",
      zIndex: "999",
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused
          ? focusedBackgroundColor
          : focusedBackgroundColor, // Keeps hover state consistent
      },
    };
  },
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--placeholder-color)",
      fontFamily: "Inter,sans-serif",
      // fontSize: "14px",
      fontWeight: "400",
      opacity: "1",
      // position: "absolute",
      // top: "30%",
      whiteSpace: "nowrap",
    };
  },
  multiValue: (base) => ({
    ...base,
    fontFamily: "Inter,sans-serif ",
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    ...(state.selectProps.menuIsOpen
      ? {
        transform: "rotate(180deg)",
      }
      : {}),
  }),
};
